import { TARGET_TYPE, TARGET_TYPE_MAP } from '../helpers/constants';

export const getTargetStrings = (rule) => {
  const firstTarget = rule.TargetCondition1;
  const isCustomLabel = firstTarget === TARGET_TYPE.CustomLabel;
  const values = isCustomLabel ? [`${TARGET_TYPE_MAP[firstTarget]}`] : [];

  [1, 2, 3].forEach((id) => {
    const target = rule[`TargetCondition${id}`];
    if (target) {
      const formattedValue = isCustomLabel ? `(${rule[`TargetValue${id}`]})` : `${TARGET_TYPE_MAP[target]} (${rule[`TargetValue${id}`]})`;
      values.push(formattedValue);
    }
  });

  return isCustomLabel ? [values.join(' ')] : values;
};

export const extractTargetsFromViewModel = assetGroupUrlRules => ({ urlTargets: assetGroupUrlRules.map(rule => getTargetStrings(rule)) });

export const isCategoryOrCustomLabel = (target) => target === TARGET_TYPE.Category || target === TARGET_TYPE.CustomLabel;

export const getPlaceHolderText = (i18n, selectedTargetType) => {
  switch (selectedTargetType) {
    case TARGET_TYPE.Url:
      return i18n.getString(_TL_('Enter URL rule'));
    case TARGET_TYPE.PageTitle:
      return i18n.getString(_TL_('Enter page title'));
    case TARGET_TYPE.PageContent:
      return i18n.getString(_TL_('Enter page content'));
    case TARGET_TYPE.Category:
      return i18n.getString(_TL_('Enter category'));
    case TARGET_TYPE.CustomLabel:
      return i18n.getString(_TL_('Enter custom label'));
    default:
      return '';
  }
};

